import type RootStore from '@stores/root.store';

import { MobXProviderContext } from 'mobx-react';
import { useContext } from 'react';

/** Returns the current `RootStore` instance, providing access to associated sub-stores.
 * @example const { processStore } = useStores();
 */
const useStores = (): RootStore => useContext(MobXProviderContext) as RootStore;

export default useStores;
